
import { Procurement } from '@/types/database.types';
import { sendTelegramNotification } from '../telegram/send';
import { formatNewProcurementNotification } from '../telegram/formatters';

/**
 * Send Telegram notification for new procurement
 */
export const sendNewProcurementNotification = async (procurement: Procurement): Promise<void> => {
  try {
    console.log('Sending Telegram notification for new procurement:', procurement.id);
    const notificationMessage = formatNewProcurementNotification(procurement);
    await sendTelegramNotification(
      notificationMessage,
      procurement.id
    );
    console.log('Telegram notification sent successfully');
  } catch (notificationError) {
    console.error('Failed to send Telegram notification:', notificationError);
    // Don't throw error for notification failure - procurement should still be created
  }
};
